import { ArrowUpRight } from 'lucide-react';
import styles from './CreditHealthScore.module.css';
import SemiPieChart from './PieChart';
import { useAuth } from '../../../auth/Auth';
import { getEquifaxCreditHealthUrl } from '../../../auth/_requests';
import { useState } from 'react';
import { ApiResponse } from '../../../helpers/utils/types';
//import { showToast } from '../../../helpers/utils/showToast';
import { ButtonSpinner } from '../../../helpers/UI/ButtonSpinner/ButtonSpinner';
//import { usePopupAuth } from '../../../helpers/hooks/usePopupAuth';
import { InlineAlert } from '../../../helpers/UI/InlineAlert/InlineAlert';
import { useNavigate } from 'react-router-dom';

const CreditHealthScore = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [meterUrl, setMeterUrl] = useState<string | undefined>('');
  // const [meterLoading, setMeterLoading] = useState(false);
  const [serverError, setServerError] = useState<string | null | undefined>(null);
  const getUrl = async () => {
    setLoading(true);
    try {
      const response = await getEquifaxCreditHealthUrl(auth?.data.token, 'creditMeter');
      if (response) {
        setMeterUrl(response?.data?.url);
      }
    } catch (error) {
      const customError = error as ApiResponse;
      let message = '';

      switch (customError.message) {
        case 'unable_to_get_equifax_auth_token':
          message = 'Unable to get Equifax authentication token. Please try again later.';
          break;
        case 'user_not_found':
          message = 'User not found. Please check your account details.';
          break;
        case 'error_while_getting_report_id':
          message = 'Error while retrieving report ID. Please try again later.';
          break;
        case 'unable_to_get_report_id':
          message = 'Unable to get report ID. Please check your account status.';
          break;
        case 'error_while_verifying_report_id':
          message = 'Error while verifying report ID. Please try again later.';
          break;
        case 'unable_to_verify_report_id':
          message = 'Unable to verify report ID. Please check your account status.';
          break;
        case 'no_hit_found_for_user':
          message = 'No hit found for the user. Please ensure your account is set up correctly.';
          break;
        case 'multiple_hit_found_for_user':
          message = 'Multiple hits found for the user. Please contact support for assistance.';
          break;
        case 'invalid_date_of_birth_format':
          message = 'Invalid date of birth format. Please ensure your date of birth is correct.';
          break;
        case 'last_name_is_required':
          message = 'Last name is required. Please ensure your last name is provided.';
          break;
        case 'first_name_is_required':
          message = 'First name is required. Please ensure your first name is provided.';
          break;
        case 'tenant_identity_not_verified':
          message = 'Complete your Identity Verification to view your credit score for free!';
          break;
        default:
          message = 'An unexpected error occurred. Please try again later.';
          break;
      }

      setServerError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/*Equifax SSO will not work on local due to DSR cookie not being set correctly*/}

      {meterUrl ? (
        <>
          {/* <button className='submitBtn' onClick={handleLogin}>
            Login to Equifax Credit Health
          </button> */}
          <div className='w-full'>
            <iframe
              width='500'
              height='600'
              frameBorder='0'
              id='equifaxIframe'
              title='Equifax Credit Health'
              src={meterUrl}
            ></iframe>
          </div>
        </>
      ) : (
        <main className={styles.main}>
          <div className={styles.statsOuter}>
            <div className={styles.creditTextOuter}>
              <SemiPieChart />
              <p className={styles.creditText}>Good credit score!</p>
            </div>

            <p className={styles.text}>
              Complete your Identity Verification to view your credit score for{' '}
              <span className='font-semibold'>free</span>!
            </p>
          </div>
          {serverError && (
            <InlineAlert
              type='error'
              message={serverError || ''}
              dismissible
              onDismiss={() => setServerError('')}
            />
          )}
          <div className={styles.buttonsOuter}>
            <button className={styles.submitBtn} onClick={getUrl} disabled={loading}>
              <span> {loading ? <ButtonSpinner /> : 'Show my credit score'}</span>
              <ArrowUpRight />
            </button>
            {window.location.pathname === '/dashboard' && (
              <button className={styles.btn2} onClick={() => navigate('/rent-reporting')}>
                Enable free rent reporting
              </button>
            )}
          </div>
        </main>
      )}
    </>
  );
};
export default CreditHealthScore;
